<template>
  <PossibilitiesDesktop v-if="isDesktop" :animation-enabled="animationEnabled" />
  <PossibilitiesMobile v-else :animation-enabled="animationEnabled" />
</template>

<script>
import { mapGetters } from 'vuex';
import PossibilitiesDesktop from './possibilities-desktop';
import PossibilitiesMobile from './possibilities-mobile';

export default {
  props: {
    animationEnabled: {
      type: Boolean,
      default: true,
    },
  },
  components: { PossibilitiesDesktop, PossibilitiesMobile },
  computed: {
    ...mapGetters('layoutModule', ['isDesktop']),
  }
};
</script>
